import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { IPatientInfo } from '../ipatient-info';
import { PatientAppointmentHistoryComponent } from "../../appointment/patient-appointment-history/patient-appointment-history.component";
import { PersonalDetailsComponent } from './personal-details/personal-details.component';
import { AddressDetailsComponent } from "./address-details/address-details.component";
import { DialogUtils } from 'src/app/common/utils/dialog.utils';
import { MedicalRecordComponent } from './medical-record/medical-record.component';
import { MedicalRecordService } from './medical-record/medical.service';

@Component({
  selector: 'app-patient-view',
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    TranslateModule,
    PatientAppointmentHistoryComponent,
    PersonalDetailsComponent,
    AddressDetailsComponent,
    MedicalRecordComponent
  ],
  templateUrl: './patient-view.component.html',
  styleUrl: './patient-view.component.scss'
})
export class PatientViewComponent implements OnInit {
  patientDetails: IPatientInfo | undefined;
  appointmentHistoryFlag: boolean = false;
  medicalRecordFlag: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: { patient?: IPatientInfo },
    private dialogRef: MatDialogRef<PatientViewComponent>,
    private dialogUtils: DialogUtils,
    private medicalRecordService: MedicalRecordService
  ) { }

  ngOnInit(): void {
    this.patientDetails = this._data.patient
      ? {
        ...this._data.patient,
        address: this.normalizeAddresses(this._data.patient.address || [])
      }
      : undefined;
    this.medicalRecordService.getMedicalRecordByPatientID(Number(this.patientDetails?.id)).subscribe(records => {
      this.medicalRecordFlag = records.result.length > 0;
    });
  }

  private normalizeAddresses(addresses: IPatientInfo['address'] = []): IPatientInfo['address'] {
    const explicitPermanentAddress = addresses.find(address => address?.isPermanent === true);
    const explicitCurrentAddress = addresses.find(address => address?.isPermanent === false);
    const untypedAddresses = addresses.filter(address => address?.isPermanent === undefined);

    const permanentAddress = explicitPermanentAddress ?? (!explicitCurrentAddress ? untypedAddresses[0] : undefined);
    const currentAddress = explicitCurrentAddress ??
      untypedAddresses.find(address => address !== permanentAddress);

    return [
      {
        id: permanentAddress?.id || 0,
        address1: permanentAddress?.address1 || '',
        address2: permanentAddress?.address2 || '',
        pincode: permanentAddress?.pincode || '',
        country: permanentAddress?.country || '',
        state: permanentAddress?.state || '',
        district: permanentAddress?.district || '',
        area: permanentAddress?.area || '',
        taluka: permanentAddress?.taluka || '',
        isPermanent: true
      },
      {
        id: currentAddress?.id || 0,
        address1: currentAddress?.address1 || '',
        address2: currentAddress?.address2 || '',
        pincode: currentAddress?.pincode || '',
        country: currentAddress?.country || '',
        state: currentAddress?.state || '',
        district: currentAddress?.district || '',
        area: currentAddress?.area || '',
        taluka: currentAddress?.taluka || '',
        isPermanent: false
      }
    ];
  }

  onHistoryLength(length: number) {
    this.appointmentHistoryFlag = length > 0;
  }

  onMedicalRecordLength(length: number) {
    this.medicalRecordFlag = length > 0;
  }

  get hasAddressOrContact(): boolean {
    const addressHasData = this.patientDetails?.address?.some(addr =>
      addr.address1 || addr.address2 || addr.area || addr.country || addr.district || addr.state || addr.pincode || addr.taluka
    );

    const contactHasData = this.patientDetails?.contactInfo?.some(contact =>
      contact.contact || contact.phone || contact.email
    );

    return !!(addressHasData || contactHasData);
  }

  onClose() {
    this.dialogUtils.closeSidePanel(this.dialogRef);
  }

}
